module.exports = __webpack_public_path__ + "static/media/whatsapp.66f16d5e.svg";